<!-- 该案例暂时不提供 -->
<template>
  <div>NA</div>
</template>

<style src="@/assets/css/cases.css" scoped></style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image: require("@/assets/img/Logo.jpg"),
            title: "虚拟制片：《梦之海》",
            description_no_1: `
               <strong class="bold-text">1. 引言</strong>
            `,
            description_no_2: `
               <strong class="bold-text">2. 虚拟制片技术</strong>
            `,
            description_no_3: `
               <strong class="bold-text">3. 技术实施过程中的挑战与解决方案</strong>
            `,
            description_no_4: `
               <strong class="bold-text">4. 《梦之海》剧组的反馈与认可</strong>
            `,
          description_1: `
作为一个在影视技术领域具有深厚底蕴和前瞻视野的团队，我们团队长期致力于推动影视制作技术的创新与发展。凭借在虚拟制片技术领域的深厚积累与持续创新，我们在行业内树立了良好的口碑，并赢得了众多合作伙伴的信赖与认可。
电视剧《梦之海》改编自刘慈欣创作的同名科幻小说，以近未来时期为时代背景，讲述了所有的地表水在毫无预兆的情况下升入太空，致使人类失去了海洋，面临生存危机。其拍摄过程对技术支持的要求极高。剧组希望借助先进的虚拟制片技术，打造出逼真且富有创意的视觉效果，以提升剧集的观赏体验。
在了解到《梦之海》剧组的技术需求后，我们就合作事宜进行了深入的沟通与探讨。通过充分展示我们在虚拟制片技术方面的实力与成果，双方建立了互信的合作关系。
            `,
          description_2: `
虚拟制片技术是一种利用计算机图形学、虚拟现实和增强现实等技术手段，在虚拟环境中进行影视拍摄与制作的技术。它能够在拍摄前对场景、角色、灯光等进行精确的模拟与预演，帮助导演和摄影师更好地把握拍摄效果，提高拍摄效率与质量。同时，虚拟制片技术还能够实现场景的无缝切换与特效的实时渲染，为观众带来更加震撼的视觉效果。作为虚拟制片行业的先行者，我们在虚拟制片技术领域取得了多项创新与突破。我们搭建了一套高效且易于操作的虚拟制片系统，能够实现对场景、角色、灯光等元素的精确控制与调整。
            `,
          description_3: `

在虚拟制片技术的实施过程中，我们确实遭遇了一系列复杂而多样的挑战。这些挑战不仅来自于技术层面的复杂性，还涉及到团队协作、场景设计以及时间管理等多个方面。
首先，电视剧《梦之海》的IP概念设计非常独特，包含了宇宙、冰川、末日废土等特殊场景。这些场景不仅要求我们在视觉上达到高度的真实感，还需要在剧情上保持连贯性和一致性。因此，我们需要根据剧情的需要，不断调整和优化虚拟场景，以确保它们在画面上的表现与故事情感相符合。这一过程需要大量的时间和精力投入，涉及到对场景细节的反复推敲和修改。
其次，虚拟制片技术对于双方团队的协同合作水平提出了极高的要求。在制片过程中，我们团队与《梦之海》剧组进行了紧密的合作，通过定期的制片会议，共同商讨和解决虚拟场景制作中遇到的问题。我们为剧组提供了虚拍片段的全流程、全分镜拍摄指导建议，帮助导演和摄影师更好地理解如何在虚拟环境中进行拍摄。同时，我们还派遣了专业的技术人员参与拍摄流程，根据导演的指令动态调整背景屏幕中的显示效果，确保拍摄效果符合预期。
此外，在虚拟制片技术的实施过程中，我们还面临了时间管理的挑战。由于电视剧的拍摄进度紧张，我们需要在既定的时间内完成所有虚拟场景的制作和拍摄任务。因此，我们需要制定详细的时间计划，合理安排各个阶段的工作进度，确保每个环节都能够按时完成。
值得一提的是，虚拟制片技术的成功实施，也离不开我们团队在技术创新方面的努力。我们不断探索新的技术手段和解决方案，以提高虚拟场景的真实感和制作效率。例如，我们采用了先进的渲染技术和光影模拟技术，使得虚拟场景在视觉上更加逼真；同时，我们还开发了一套高效的多场景管理方案，方便团队成员对场景进行快速调整和优化。
            `,
          description_4: `

电视剧《梦之海》剧组对我们的虚拟制片技术给予了高度评价。他们表示，通过运用虚拟制片技术，他们得以更加灵活地拍摄各种复杂场景，大大提高了拍摄效率和质量。同时，虚拟制片技术还为他们带来了更多的创意空间，使得剧集在视觉效果上呈现出前所未有的震撼与新奇。
在技术应用过程中，剧组深刻体会到了虚拟制片技术的优势与魅力。他们表示，通过虚拟制片技术，他们能够更加直观地预览拍摄效果，及时发现并解决问题。同时，虚拟制片技术还为他们节省了大量的拍摄时间和成本，使得他们能够更加专注于剧情的打磨和角色的塑造。
未来，云翰虹章将继续加强技术研发，并通过与宁波诺丁汉国际创新创业产业园共同开展多项合作项目来拓展业务领域。双方将积极探索在数字资产、AIGC，物联网等前沿领域的合作机会，共同推动科技成果转化和产业升级。,
          `
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 1,
            image: require("@/assets/img/Logo.jpg"),
            title:
              "Rosy Nebula officially settled in UNNC International Innovation and Entrepreneurship Industrial Park",
            description:`
               On May 1, 2023, to establish industry-university-research cooperation with the university, Rosy Nebula officially settled in the IEB building of the UNNC International Innovation and Entrepreneurship Industrial Park.
               International Innovation and Entrepreneurship Industrial Park was set up in September 2017. With the theme of "International Talent Attraction", it provides supporting services for Chinese enterprises to go international and sets a platform for foreign enterprises to enter Chinese market by introducing talents, guiding development, and accelerating financing. The incubator wants to make IEB an international innovation center. What's more,  in the Ningbo Science and Technology Business Incubator recognition list in 2020, it is the only one based at university.
               In the future, Rosy Nebula will continue to strengthen its technological development and expand its business areas by jointly undertaking multiple cooperation projects with the International Innovation and Entrepreneurship Industrial Park. 双方将积极探索在数字资产、AIGC，物联网等前沿领域的合作机会，共同推动科技成果转化和产业升级。
               ,`
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>